import React from 'react';
import { Divider, Header, List } from 'semantic-ui-react';
import Emoji from '../../../Reusable/Emoji';

import './general.scss';

import data from './generalData';

const General = () => {
  
  return (
    
    <div id="general">
        <Divider horizontal>
          <Header className='custom-header' as='h4'>
            <Emoji emoji='heart_eyes' set='google' size={26} />
            Front End
          </Header>
        </Divider>
        <List divided relaxed>
          {data.front.map((item) => (
            <List.Item key={item.id}>
              <List.Icon as='i' className={`${item.icon} colored`} size='large' verticalAlign='middle' />
              <List.Content>
                <List.Header as='h3'>{item.name}</List.Header>
                <List.Description>{item.desc}</List.Description>
              </List.Content>
            </List.Item>
          ))}
        </List>
        <Divider horizontal>
          <Header className='custom-header' as='h4'>
            <Emoji emoji='nerd_face' set='google' size={26} />
            Back End
          </Header>
        </Divider>
        <List divided relaxed>
          {data.back.map((item) => (
            <List.Item key={item.id}>
              <List.Icon as='i' className={`${item.icon} colored`} size='large' verticalAlign='middle' />
              <List.Content>
                <List.Header as='h3'>{item.name}</List.Header>
                <List.Description>{item.desc}</List.Description>
              </List.Content>
            </List.Item>
          ))}
        </List>
    </div>
    
  );  
  
};

General.propTypes = {
};

export default General;
